import { render, staticRenderFns } from "./AppStoreHeaderForUsageTime.vue?vue&type=template&id=1a540087"
import script from "./AppStoreHeaderForUsageTime.vue?vue&type=script&lang=js"
export * from "./AppStoreHeaderForUsageTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports